import { toast } from "react-toastify";
export const showError = (message) => {
    toast.error(message);
    toast.clearWaitingQueue();
};

// export const showSuccess = (message) => {
//   // console.log(toast);
//   toast.success(message);
//   toast.clearWaitingQueue();
// };

// let toastId = null;

export const showSuccess = (message) => {
  toast.dismiss(); // Dismiss all current toasts
  toast.success(message, {
    autoClose: 3000,
    pauseOnHover: true,
  });
};


export const showAlert = (message) => {
  // console.log(toast);
  toast.warning(message);
  toast.clearWaitingQueue();
};

export const setItemWithExpiry = (key, value, expiryInDays)  => {
  const now = new Date();
  const expiry = now.getTime() + expiryInDays * 24 * 60 * 60 * 1000; 
  const item = {
      value: value,
      expiry: expiry,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export const getItemWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
  
    let item;
    try {
      item = JSON.parse(itemStr);
    } catch (error) {
      localStorage.removeItem(key); 
      return null;
    }
  
    const now = new Date();
    // console.log(now.getTime() , item.expiry, 'exp');

    if (!item.expiry || now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
  
    return item.value;
  };
  

  
export const  clearAllStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
}
  
export const errorDonotShowForPath = ()=> {
  return ['auth/login','auth/login']
}